import { DefaultTheme, InterpolationFunction, ThemeProps } from 'styled-components';
import { typographyMixin, TypographySize, TypographyType } from './typographyMixin';

const makeTypography = (size: TypographySize, type: TypographyType): InterpolationFunction<ThemeProps<DefaultTheme>> => (props) =>
  typographyMixin({
    ...props,
    type,
    size,
  });

const m = makeTypography;

export const predefinedMixins = {
  xxl: {
    regular: m('xxl', 'regular'),
    contrastInvert: m('xxl', 'contrastInvert'),
  },
  xl: {
    regular: m('xl', 'regular'),
    contrastInvert: m('xl', 'contrastInvert'),
  },
  lg: {
    regular: m('lg', 'regular'),
    contrastInvert: m('lg', 'contrastInvert'),
  },
  md: {
    highContrast: m('md', 'highContrast'),
    regular: m('md', 'regular'),
    lowContrast: m('md', 'lowContrast'),
    url: m('md', 'url'),
    contrastInvert: m('md', 'contrastInvert'),
  },
  sm: {
    highContrast: m('sm', 'highContrast'),
    regular: m('sm', 'regular'),
    lowContrast: m('sm', 'lowContrast'),
    url: m('sm', 'url'),
    success: m('sm', 'success'),
    warning: m('sm', 'warning'),
    error: m('sm', 'error'),
    contrastInvert: m('sm', 'contrastInvert'),
  },
  xs: {
    highContrast: m('xs', 'highContrast'),
    regular: m('xs', 'regular'),
    lowContrast: m('xs', 'lowContrast'),
    disabled: m('xs', 'disabled'),
    url: m('xs', 'url'),
    success: m('xs', 'success'),
    warning: m('xs', 'warning'),
    error: m('xs', 'error'),
    contrastInvert: m('xs', 'contrastInvert'),
  },
  xxs: {
    highContrast: m('xxs', 'highContrast'),
    regular: m('xxs', 'regular'),
    lowContrast: m('xxs', 'lowContrast'),
    disabled: m('xxs', 'disabled'),
    url: m('xxs', 'url'),
    success: m('xxs', 'success'),
    warning: m('xxs', 'warning'),
    error: m('xxs', 'error'),
    contrastInvert: m('xxs', 'contrastInvert'),
  },
};
